import { defaultProps } from '@config/antd.config';
import { Popover as PopoverExt } from 'antd';
import { PopoverProps } from 'antd/lib/popover';
import React from 'react';

type TExtendPopoverProps = PopoverProps

export const Popover = (props: TExtendPopoverProps) => {
  return <PopoverExt {...defaultProps.tooltipProps} {...props}>
    {props.children}
  </PopoverExt>
}

